import { c as _c } from "react/compiler-runtime";
import { AlertCircle, CheckCircle2, Mail } from "lucide-react";
import { cn } from "#lib/utils.js";
import { Button } from "./button";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StatusMessage(t0) {
  const $ = _c(12);
  const {
    message,
    variant,
    action,
    actionLabel: t1,
    className
  } = t0;
  const actionLabel = t1 === undefined ? "Forts\xE4tt" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      success: CheckCircle2,
      error: AlertCircle,
      confirmation: Mail
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const Icon = t2[variant];
  let t3;
  if ($[1] !== Icon || $[2] !== action || $[3] !== actionLabel || $[4] !== className || $[5] !== message || $[6] !== variant) {
    const variantClasses = {
      success: "bg-green-50 text-green-700",
      error: "bg-red-50 text-red-700",
      confirmation: "bg-blue-50/80 text-blue-500"
    }[variant];
    const buttonClasses = {
      success: "text-green-700 hover:text-green-800",
      error: "text-red-700 hover:text-red-800",
      confirmation: "text-blue-600 hover:text-blue-700"
    }[variant];
    let t4;
    if ($[8] !== Icon) {
      t4 = /*#__PURE__*/_jsx(Icon, {
        className: "h-5 w-5 shrink-0"
      });
      $[8] = Icon;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== message) {
      t5 = /*#__PURE__*/_jsx("div", {
        className: "flex-1",
        children: message
      });
      $[10] = message;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t3 = /*#__PURE__*/_jsxs("div", {
      className: cn("flex items-center gap-2 rounded-md p-4 text-sm", variantClasses, className),
      children: [t4, t5, action && /*#__PURE__*/_jsx(Button, {
        variant: "ghost",
        size: "sm",
        onClick: action,
        className: cn("hover:bg-white/10", buttonClasses),
        children: actionLabel
      })]
    });
    $[1] = Icon;
    $[2] = action;
    $[3] = actionLabel;
    $[4] = className;
    $[5] = message;
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}